/* Lead page: Klaviyo list sign up, live switch after the countdown, redirect after sign up */
(() => {
  if (window.kopLeadInit) return;
  window.kopLeadInit = true;

  const KLAVIYO_REVISION = '2024-10-15';

  const findKlaviyoKey = (explicitKey) => {
    if (explicitKey) return explicitKey;
    const scripts = document.querySelectorAll('script[src*="klaviyo.com"]');
    for (const script of scripts) {
      const src = script.getAttribute('src') || '';
      const byParam = src.match(/company_id=([A-Za-z0-9]+)/);
      if (byParam) return byParam[1];
      const byPath = src.match(/onsite\/js\/([A-Za-z0-9]{5,8})\//);
      if (byPath) return byPath[1];
    }
    return '';
  };

  const redirectLater = (url) => {
    if (!url) return;
    window.setTimeout(() => { window.location.href = url; }, 1500);
  };

  const subscribe = async ({ key, list, email, firstName, source }) => {
    const attributes = { email };
    if (firstName) attributes.first_name = firstName;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Lead page',
          profile: { data: { type: 'profile', attributes } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(key)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
  };

  const bindForm = (fields) => {
    const form = fields.closest('form');
    if (!form || form.dataset.kopLeadBound) return;
    form.dataset.kopLeadBound = 'true';

    form.addEventListener('submit', async (event) => {
      if (fields.dataset.mode !== 'klaviyo_list') return;
      const key = findKlaviyoKey(fields.dataset.key);
      const list = fields.dataset.list;
      if (!key || !list) return; /* fall back to the Shopify customer form */

      event.preventDefault();
      const email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      const firstName = (form.querySelector('[name="contact[first_name]"]') || {}).value || '';
      const error = form.querySelector('[data-kop-lead-error]');
      const success = form.querySelector('[data-kop-lead-success]');
      if (error) error.hidden = true;
      form.classList.add('is-loading');

      try {
        await subscribe({ key, list, email: email.trim(), firstName: firstName.trim(), source: fields.dataset.source });
        fields.hidden = true;
        if (success) success.hidden = false;
        document.dispatchEvent(new CustomEvent('kop:lead:subscribed', { detail: { email } }));
        redirectLater(fields.dataset.redirect);
      } catch (err) {
        if (error) error.hidden = false;
      } finally {
        form.classList.remove('is-loading');
      }
    });
  };

  const setLive = (root) => {
    root.classList.add('is-live');
    const live = root.querySelector('[data-kop-lead-live]');
    if (live) live.hidden = false;
  };

  const init = (root) => {
    root.querySelectorAll('[data-kop-lead-form]').forEach(bindForm);

    const posted = root.querySelector('[data-kop-lead-success][data-redirect]:not([hidden])');
    if (posted) redirectLater(posted.dataset.redirect);

    const liveAt = Date.parse(root.dataset.liveAt || '');
    if (!Number.isNaN(liveAt)) {
      const wait = liveAt - Date.now();
      if (wait <= 0) setLive(root);
      else if (wait < 2147483647) window.setTimeout(() => setLive(root), wait);
    }
  };

  const initBar = () => {
    const bar = document.querySelector('[data-kop-lead-bar]');
    if (!bar || bar.dataset.kopBound) return;
    bar.dataset.kopBound = 'true';
    const hero = document.querySelector('[data-kop-lead]');
    if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(hero);
  };

  const run = () => {
    document.querySelectorAll('[data-kop-lead]').forEach(init);
    initBar();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kop-lead]').forEach(init);
  });
})();
